import { PlayCircle, SketchLogo } from '@phosphor-icons/react'
import { useRouter } from 'next/router'
import { useOrganisationContext } from 'src/lib/contexts/OrganisationContext'
import { useUser } from 'src/lib/contexts/UserContext'
import { useLocale } from 'src/lib/hooks/useLocal'
import {
  createNavigationMenuItems,
  checkoutSections,
  cartSections,
  shopPassSections
} from 'src/components/navigation/nav-items'
import { NavigationItem } from 'src/components/navigation/PrimaryNavBarComponents/PrimaryTabs'
import { useState } from 'react'

export const TrialBanner = () => {
  const { t } = useLocale()
  const router = useRouter()
  const currPath = router.pathname
  const { user, isUserConfigured } = useUser()
  const {
    getters: { organisationData, isShopConnected, billingPopUp }
  } = useOrganisationContext()

  const [showBannerVideo, setShowBannerVideo] = useState(false)

  const hasOverdueInvoices = billingPopUp.hasOverdueInvoices && !user?.isSuperAdmin
  const allNavItems = createNavigationMenuItems(t, isShopConnected, isUserConfigured, hasOverdueInvoices)
  const currentTabObj = allNavItems?.find((item: NavigationItem) => currPath.includes(item?.path?.split('/')[1]))

  const allSecondarySections = [
    ...checkoutSections.flatMap(section => section.items),
    ...cartSections.flatMap(section => section.items),
    ...shopPassSections.flatMap(section => section.items)
  ]

  const currentSecondaryTabObj = allSecondarySections.find(item => currPath.startsWith(item.path))
  const tabParentPermissionName = currentTabObj?.rbacPermission || currentSecondaryTabObj?.rbacPermission
  const tabParentPermissionNames = Array.isArray(tabParentPermissionName)
    ? tabParentPermissionName
    : tabParentPermissionName
    ? [tabParentPermissionName]
    : []
  const activeApp = organisationData.shopfloApps?.find(
    app =>
      app?.merchantAppDetails?.active &&
      app?.linkedTabName &&
      tabParentPermissionNames.includes(app.linkedTabName) &&
      app?.merchantAppDetails?.trial_period_status !== 'COMPLETED' &&
      app?.merchantAppDetails?.num_days_left_on_trial
  )

  if (!activeApp) return <></>

  const daysLeft = activeApp?.merchantAppDetails?.num_days_left_on_trial
  const activeAppVideo = activeApp?.media?.find(item => item.type === 'VIDEO' && item.tags?.[0] === 'HOW_TO_VIDEO')
  const daysLeftText =
    daysLeft === 1
      ? t('navigation.trail_day_left', { days: daysLeft })
      : t('navigation.trial_days_left', { days: daysLeft })

  return (
    <div className='flex gap-2 pb-4 px-5  items-center -mx-6 '>
      <div className='flex gap-2 items-center border-1 rounded-2xl py-1 px-3 text-carbon'>
        <SketchLogo size={16} />
        <span className='text-text-xs-medium'>{t('navigation.trial')} </span>
        <span className='p-[3px] bg-gray-dark rounded-full'></span>
        <span className='text-text-xs-medium'>{daysLeftText}</span>
      </div>
      {activeAppVideo && (
        <div
          className='flex gap-2 items-center cursor-pointer border-1 rounded-full px-3 py-1'
          onClick={() => setShowBannerVideo(true)}
        >
          <PlayCircle size={16} />
          <p className='text-text-xs-medium text-carbon'>{t('how_to_use_this_feature')}</p>
        </div>
      )}
      {activeAppVideo && showBannerVideo && (
        <div
          className='fixed inset-0 bg-black/70 flex justify-center items-center z-[999999]'
          onClick={() => setShowBannerVideo(false)}
        >
          <div className='rounded-lg max-w-3xl max-h-[80%] overflow-hidden'>
            <iframe
              width={activeAppVideo?.width ?? '680'}
              height={activeAppVideo?.height ?? '400'}
              src={activeAppVideo?.url}
              title='YouTube video player'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
              allowFullScreen
              className='rounded-lg'
            ></iframe>
          </div>
        </div>
      )}
    </div>
  )
}
